module.exports = __webpack_public_path__ + "static/img/08.86155307.png";